import { BehaviorSubject, Observable } from 'rxjs';
import { DepositAssetsFacade } from './deposit-assets.facade';

import type {
  DepositPlanAlt,
  DepositPlanDto,
  NewDepositAssetsPlan,
} from '@coin-depo-types';

export abstract class DepositAssetsBaseService
  implements DepositAssetsFacade
{
  protected abstract depositPlans$: BehaviorSubject<DepositPlanDto[]>;
  protected abstract depositPlansAlt$: BehaviorSubject<DepositPlanAlt[]>;
  protected abstract depositDropdown$: BehaviorSubject<NewDepositAssetsPlan[]>;

  get cachedDepositPlans$(): Observable<DepositPlanDto[]> {
    return this.depositPlans$.asObservable();
  }

  get cachedDepositPlansAlt$(): Observable<DepositPlanAlt[]> {
    return this.depositPlansAlt$.asObservable();
  }

  get cachedDepositDropdown$(): Observable<NewDepositAssetsPlan[]> {
    return this.depositDropdown$.asObservable();
  }

  abstract cachedDepositPlansSelect$: Observable<DepositPlanDto[]>;

  abstract getDepositAssets(id: number): Observable<any>;
  abstract updateNewDepositDropdown(): Observable<any>;

  abstract getDepositDropdownById(
    id: string | number
  ): Observable<NewDepositAssetsPlan[]>;

  abstract getSnapshotDepositDropdownById(
    id: string | number
  ): NewDepositAssetsPlan[];

  abstract updateDepositPlans(): Observable<any>;
  abstract updateDepositPlansAlt(): Observable<any>;

  getDepositPlansAltSnapshot(): DepositPlanAlt[] {
    return this.depositPlansAlt$.value;
  }
}